import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { Play } from 'lucide-react';
import { useLanguage } from './LanguageContext';
export function HistoricMoments() {
  const {
    t
  } = useLanguage();
  const moments = [{
    title: t('history.upset'),
    year: '1950',
    videoId: 'U4ESTvxyqsI',
    colSpan: 'md:col-span-2',
    customImage: 'https://img.youtube.com/vi/U4ESTvxyqsI/sddefault.jpg'
  }, {
    title: t('history.donovan'),
    year: '2010',
    videoId: 'wm7ievQ2bHo',
    colSpan: 'md:col-span-1',
    customImage: 'https://img.youtube.com/vi/wm7ievQ2bHo/sddefault.jpg'
  }, {
    title: t('history.howard'),
    year: '1994',
    videoId: '863rTle6CKY',
    colSpan: 'md:col-span-1',
    customImage: 'https://img.youtube.com/vi/863rTle6CKY/sddefault.jpg'
  }, {
    title: t('history.nationsLeague'),
    year: '2010-2022',
    videoId: '6mi1VfbjGB4',
    colSpan: 'md:col-span-2',
    customImage: 'https://img.youtube.com/vi/6mi1VfbjGB4/sddefault.jpg'
  }, {
    title: t('history.pulisic'),
    year: '2002',
    videoId: 'nrEbjPbPbL0',
    colSpan: 'md:col-span-1',
    customImage: 'https://img.youtube.com/vi/nrEbjPbPbL0/sddefault.jpg'
  }, {
    title: t('history.run2002'),
    year: '2002',
    videoId: '8T8u0K52Lzs',
    colSpan: 'md:col-span-2',
    customImage: 'https://img.youtube.com/vi/8T8u0K52Lzs/sddefault.jpg'
  }, {
    title: t('history.goldCup'),
    year: '2021',
    videoId: 'cpPazeqrD8U',
    colSpan: 'md:col-span-1',
    customImage: 'https://img.youtube.com/vi/cpPazeqrD8U/sddefault.jpg'
  }, {
    title: t('history.hosts'),
    year: '1990-2006',
    videoId: '-XEMQYpW48w',
    colSpan: 'md:col-span-2',
    customImage: 'https://img.youtube.com/vi/-XEMQYpW48w/sddefault.jpg'
  }];
  return <section className="py-12 md:py-24 bg-usa-black" data-id="element-171">
      <div className="container mx-auto px-6 md:px-12" data-id="element-172">
        <div className="mb-8 md:mb-12" data-id="element-173">
          <motion.h2 initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="text-usa-red font-oswald uppercase tracking-widest text-sm font-bold mb-3" data-id="element-174">
            {t('history.label')}
          </motion.h2>
          <motion.h3 initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-3xl md:text-5xl font-oswald font-bold uppercase" data-id="element-175">
            {t('history.title1')}{' '}
            <span className="text-usa-silver" data-id="element-176">{t('history.title2')}</span>
          </motion.h3>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6" data-id="element-177">
          {moments.map((moment, index) => <motion.div key={index} initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className={`relative rounded-2xl overflow-hidden aspect-video md:aspect-auto bg-[#111] ${moment.colSpan} ${moment.colSpan === 'md:col-span-2' ? 'md:h-[400px]' : 'md:h-[400px]'}`} data-id="element-178">
              <a href={`https://www.youtube.com/watch?v=${moment.videoId}`} target="_blank" rel="noopener noreferrer" className="absolute inset-0 w-full h-full group cursor-pointer block" data-id="element-179">
                <img src={moment.customImage || `https://img.youtube.com/vi/${moment.videoId}/maxresdefault.jpg`} alt={moment.title} loading="lazy" decoding="async" className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" onError={e => {
              e.currentTarget.src = `https://img.youtube.com/vi/${moment.videoId}/hqdefault.jpg`;
            }} data-id="element-180" />
                <div className="absolute inset-0 bg-gradient-to-t from-usa-black via-usa-black/40 to-transparent opacity-80 group-hover:opacity-90 transition-opacity duration-300" data-id="element-181"></div>
                {/* Play Button Overlay */}
                <div className="absolute inset-0 flex items-center justify-center transition-transform duration-300 transform group-hover:scale-110" data-id="element-182">
                  <div className="w-16 h-16 bg-usa-red/90 rounded-full flex items-center justify-center backdrop-blur-sm shadow-[0_0_30px_rgba(191,10,48,0.5)]" data-id="element-183">
                    <Play className="text-white ml-1" size={24} fill="currentColor" data-id="element-184" />
                  </div>
                </div>
                {/* YouTube badge */}
                <div className="absolute top-4 right-4 bg-[#FF0000] text-white text-[10px] font-oswald uppercase tracking-widest px-2 py-1 rounded flex items-center gap-1 z-10" data-id="element-185">
                  <Play size={10} fill="currentColor" data-id="element-186" /> YouTube
                </div>
                {/* Content */}
                <div className="absolute bottom-0 left-0 w-full p-6 md:p-8" data-id="element-187">
                  <span className="inline-block bg-usa-silver text-usa-black text-xs font-oswald uppercase tracking-widest px-2 py-1 rounded mb-3 font-bold" data-id="element-188">
                    {moment.year}
                  </span>
                  <h4 className="font-oswald text-xl md:text-3xl font-bold uppercase text-white drop-shadow-lg" data-id="element-189">
                    {moment.title}
                  </h4>
                </div>
              </a>
            </motion.div>)}
        </div>
      </div>
    </section>;
}